import en from './en';
import fr from './fr';

export const supportedLanguages = ['en', 'fr'];

export default {
  en,
  fr,
};
